import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IProiect } from '../../proiecte.interface';
import { helper } from 'src/environments/helper';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProiecteService } from '../../proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';
import { initializeEditor } from 'src/app/utils/editorConfig';
import { IUpdateGarantieForm, IUpdateGarantiePayload } from './info-inchidere-proiect.interface';
import { finalize, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppFilesService } from 'src/app/services/app-files.service';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
    selector: 'app-info-inchidere-proiect',
    templateUrl: './info-inchidere-proiect.component.html',
    styleUrls: ['./info-inchidere-proiect.component.scss']
})
export class InfoInchidereProiectComponent {
    @Input() proiect!: IProiect;
    @Output() proiectChanged: EventEmitter<void> = new EventEmitter();

    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;
    editorConfig!: AngularEditorConfig;

    isLoading = false;
    uploading = false;
    showEditField = false;
    showUploadField = false;
    passedProiectId!: number;
    form!: FormGroup;
    formFiles!: FormGroup;

    defaultParameter: { name: string; id: number } = {
        name: '-- Alegeți --',
        id: -1,
    };

    finalizare_type: { key: string; value: number }[] = [
        { key: '-- Alegeți --', value: -1 },
        { key: 'Conform', value: 1 },
        { key: 'Neconform', value: 2 },
    ];

    constructor(
        private proiecteService: ProiecteService,
        private notificationService: NotificationService,
        private fb: FormBuilder,
        private appFileService: AppFilesService,
        public permissionsService: PermissionsService,
    ) { }

    ngOnChanges(): void {
        this.passedProiectId = this.proiect.id_proiect;
    }

    ngOnInit(): void {
        this.editorConfig = initializeEditor();

        this.form = this.fb.group({
            garantie_date: new FormControl(new Date(this.proiect.garantie || ''), [Validators.required]),
            finished_type: new FormControl(this.proiect.finished_type || -1, [Validators.required, Validators.min(0)]),
            validated_obs: new FormControl(this.proiect.validated_obs || '', [Validators.required]), // "<p>Descriere<br/><p>"
        });

        this.formFiles = this.fb.group({
            files: this.fb.array([]),
        });
    }

    submitForm() {
        this.isLoading = true;

        const {
            garantie_date,
            finished_type,
            validated_obs,
        } = this.form.value as IUpdateGarantieForm;
        const payload: IUpdateGarantiePayload = {
            garantie_date: garantie_date.toISOString().split('T')[0],
            finished_type,
            validated_obs,
        };

        this.proiecteService
            .updateGarantie(this.passedProiectId, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.notificationService.warningSwal(
                        this.successTitle,
                        'Proiect actualizat cu succes!',
                        this.successIcon
                    ).then(() => {
                        this.proiectChanged.emit();
                        this.closeEditField();
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    uploadFiles() {
        this.isLoading = true;

        const files = (this.formFiles.get('files') as FormArray).value;

        // let formData = new FormData();
        // formData.append('files', files);
        // console.log(formData);

        const payload = { files };
        console.log(payload);

        this.proiecteService
            .uploadGarantieFiles(this.passedProiectId, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.notificationService.warningSwal(
                        this.successTitle,
                        'Document adăugat cu succes!',
                        this.successIcon
                    ).then(() => {
                        this.proiectChanged.emit();
                        this.closeUploadField();

                        const files = this.formFiles.get('files') as FormArray;
                        files.clear();
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    addFile(event: any, key: 'file') {
        event.eventPreventDefault = true;
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            this.uploading = true;

            const formData = new FormData();
            formData.append('file', file, file.name);

            this.proiecteService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== 'undefined' ? result : result.error;
                    if (typeof response.status_code !== 'undefined') {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== 'undefined'
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            const files = this.formFiles.get(
                                'files'
                            ) as FormArray;
                            files.push(new FormControl(result.data));

                            this.uploading = false;
                            this.notificationService.warningSwal(
                                this.successTitle,
                                helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                this.successIcon,
                            );
                        }
                    } else {
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading = false;

                    let msg;
                    try {
                        // try to catch the message from server
                        msg = result.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
        }
    }

    removeFile(index: number) {
        const files = this.form.get('files') as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }

    downloadDocument(id_document: number) {
        let fullPath = this.proiecteService.downloadDocumentURL + id_document;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(error => {
                // Handle any errors here
                console.error('Download error:', error);
                this.isLoading = false;
            });
    }

    toggleEditField() {
        this.showEditField = !this.showEditField;
    }

    closeEditField() {
        this.showEditField = false;
    }

    toggleUploadField() {
        this.showUploadField = !this.showUploadField;
    }

    closeUploadField() {
        this.showUploadField = false;
    }
}
